module.exports = __webpack_public_path__ + "img/filter_2.b5d9c6ff.svg";